// extracted by mini-css-extract-plugin
export default {"FixedHeader":"FixedHeader_FixedHeader__05uND","comeFromTop":"FixedHeader_comeFromTop__Pkc7d","title":"FixedHeader_title__f0q3o"};